import React, { useRef, useEffect } from 'react';
import Message from './Message';
import './ChatWindow.css';

const ChatWindow = ({ messages, isTyping }) => {
  const messagesEndRef = useRef(null);

  // Auto-scroll to bottom when messages change
  useEffect(() => {
    messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' });
  }, [messages, isTyping]);

  return (
    <div className="chat-messages">
      {messages.map((message, index) => (
        <Message 
          key={index} 
          type={message.type} 
          content={message.content} 
        />
      ))}
      
      {isTyping && (
        <div className="typing-indicator">
          <span></span>
          <span></span>
          <span></span>
        </div>
      )}
      
      <div ref={messagesEndRef} />
    </div>
  );
};

export default ChatWindow;
